<div class="p-fluid space-y-3" [formGroup]="formGroup">
    <div class="flex flex-col gap-1">
        <label for="markup-name">Name</label>
        <input
            id="markup-name"
            pInputText
            formControlName="name"
            placeholder="Markup name"
            class="w-full"
            maxlength="255"
            [ngClass]="{
                'ng-dirty': submitted && formGroup.get('name')?.invalid,
                'ng-invalid': submitted && formGroup.get('name')?.invalid
            }"
        />
        <small *ngIf="submitted && formGroup.get('name')?.hasError('required')" class="text-red-500">Name is required.</small>
        <small *ngIf="submitted && formGroup.get('name')?.hasError('maxlength')" class="text-red-500">Max 255 characters.</small>
    </div>

    <div class="flex flex-col gap-1">
        <label for="provider-select">Provider</label>
        <p-select
            inputId="provider-select"
            [options]="providers"
            optionLabel="explanation"
            optionValue="id"
            appendTo="body"
            formControlName="providerId"
            placeholder="Select provider"
            class="w-full"
        />
    </div>

    <div class="flex flex-col gap-1">
        <label for="price">Price</label>
        <p-inputnumber
            inputId="price"
            formControlName="price"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [min]="0"
            [ngClass]="{ 'ng-invalid ng-dirty': submitted && formGroup.get('price')?.invalid }"
        ></p-inputnumber>
        <small *ngIf="submitted && formGroup.get('price')?.hasError('required')" class="text-red-500">Price is required.</small>
        <small *ngIf="submitted && formGroup.get('price')?.hasError('min')" class="text-red-500">Price must be at least 0.</small>
    </div>

    <div class="flex flex-col gap-2">
        <label>Status</label>
        <div class="flex items-center gap-2 pl-1">
            <p-toggleswitch formControlName="active" inputId="activeToggle"></p-toggleswitch>
            <label for="activeToggle">{{ formGroup.get('active')?.value ? 'Active' : 'Inactive' }}</label>
        </div>
    </div>

    <div class="flex justify-between pt-4">
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="onCancel()"></p-button>
        <p-button [label]="mode === 'add' ? 'Add New' : 'Save'" (click)="onSave()"></p-button>
    </div>
</div>
